// Trading Cards taxonomy — shared by PostTrade, Browse, ListingCard, ListingDetail
export const TRADING_CARDS_CATEGORY = "Trading Cards";

export const CARD_GAME_GROUPS = [
  {
    group: "Trading Card Games",
    items: [
      "Pokémon",
      "Magic: The Gathering",
      "Yu-Gi-Oh!",
      "One Piece Card Game",
      "Disney Lorcana",
      "Star Wars: Unlimited",
      "Flesh and Blood",
      "Digimon",
      "Dragon Ball Super",
      "Weiss Schwarz",
      "Union Arena",
      "MetaZoo",
      "Cardfight!! Vanguard",
      "KeyForge",
    ],
  },
  {
    group: "Sports Cards",
    items: [
      "Baseball",
      "Basketball",
      "Football",
      "Hockey",
      "Soccer",
      "Wrestling / UFC",
      "Racing / F1",
      "Golf",
      "Tennis",
      "Multi-Sport",
    ],
  },
  {
    group: "Non-Sport & Other",
    items: [
      "Marvel",
      "Star Wars",
      "Garbage Pail Kids",
      "Vintage Non-Sport",
      "Entertainment / Movies",
      "Other",
    ],
  },
];

export const ALL_CARD_GAMES = CARD_GAME_GROUPS.flatMap(g => g.items);

export const CARD_TYPES = [
  { value: "single", label: "Single card" },
  { value: "sealed", label: "Sealed product" },
  { value: "lot", label: "Lot / Bundle" },
  { value: "complete_set", label: "Complete set" },
];
export const CARD_TYPE_LABELS = Object.fromEntries(CARD_TYPES.map(t => [t.value, t.label]));

export const GRADING_COMPANIES = ["PSA", "BGS", "CGC", "SGC", "TAG", "AGS", "Other"];

export const GRADES = ["10", "9.5", "9", "8.5", "8", "7.5", "7", "6.5", "6", "5", "4", "3", "2", "1", "Authentic"];

export const CARD_CONDITIONS = [
  { value: "gem_mint", label: "Gem Mint" },
  { value: "near_mint", label: "Near Mint (NM)" },
  { value: "lightly_played", label: "Lightly Played (LP)" },
  { value: "moderately_played", label: "Moderately Played (MP)" },
  { value: "heavily_played", label: "Heavily Played (HP)" },
  { value: "damaged", label: "Damaged" },
];
export const CARD_CONDITION_LABELS = Object.fromEntries(CARD_CONDITIONS.map(c => [c.value, c.label]));

export const POPULAR_CARD_GAMES = [
  "Pokémon",
  "Magic: The Gathering",
  "Yu-Gi-Oh!",
  "Baseball",
  "Basketball",
  "Football",
  "One Piece Card Game",
  "Disney Lorcana",
];
